import { useLanguage } from "../../contexts/LanguageContext";
import { isEventActive } from "../../utils/dashboardUtils";

import "./EventStatusBadge.css";

const EventStatusBadge = ({ event }) => {
  const { t } = useLanguage();

  const active = isEventActive(event);

  if (active) {
    return (
      <div className="event-status-badge active">
        <div className="status-content">
          <div className="status-text">
            <span className="status-label">
              {t("dashboard.eventStatus.active")}
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="event-status-badge inactive">
      <div className="status-content">
        <div className="status-text">
          <span className="status-label">
            {t("dashboard.eventStatus.inactive")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventStatusBadge;
